import axios from "../utils/request"
import path from "./path"

const api = {
    postLogin(username, password) {
        return axios.post(path.loginPage, {
            username,
            password
        });
    },
    // getData(){
    //     return axios.get(path.dataPage)
    // }
    getData(params) {
         return axios.get(path.dataPage, { params });
  }
}

export default api